import { render, staticRenderFns } from "./recruition-table.vue?vue&type=template&id=5d9d0970&scoped=true"
import script from "./recruition-table.vue?vue&type=script&lang=ts"
export * from "./recruition-table.vue?vue&type=script&lang=ts"
import style0 from "./recruition-table.vue?vue&type=style&index=0&id=5d9d0970&prod&lang=less&scoped=true"
import style1 from "./recruition-table.vue?vue&type=style&index=1&id=5d9d0970&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5d9d0970",
  null
  
)

export default component.exports